(function() {
  'use strict';

  window.toggleFormSubmitAction = function(form_id, button_id, are_you_sure_controller){
    var $button = $(button_id);
    var form_target = $button.data('submit-path');
    var method = $button.data('submit-method');
    var remote = $button.data('remote');

    $button.on('click', function(e){
      e.preventDefault();
      var confirm_msg = $(button_id).data('confirm-message');

      if (confirm_msg !== undefined && confirm_msg.length) {
        if ( confirm(confirm_msg) ){
          submitFormWithTarget(form_id, form_target, method, remote, are_you_sure_controller);
        }
      } else {
        submitFormWithTarget(form_id, form_target, method, remote, are_you_sure_controller);
      }
    });
  }

  function submitFormWithTarget(form_id, form_target, method, remote, are_you_sure_controller){
    //if (typeof(are_you_sure_controller) != 'undefined' ) { are_you_sure_controller.dispose(); }
    $(form_id).attr('action', form_target);
    $(form_id).attr('method', method);
    $(form_id).data('remote', remote);
    $(form_id + ' input[name="_method"]').val(method);
    $(form_id).trigger('submit.rails');
  }

})();